// extracted by mini-css-extract-plugin
module.exports = {"serverError":"LoginForm-module__serverError___1dc1J","loginForm":"LoginForm-module__loginForm___3Gr-3"};